import { ActionType } from '../action-types/index'
import { UpdateAppStateAction } from '../actions/index'
import { AppState } from "../../models"

const initialAppState: AppState = AppState.InitialLoad

const appStateReducer = (state: string = initialAppState, action: UpdateAppStateAction) => {
    switch (action.type) {
        case ActionType.UpdateAppState:
            return state = action.payload
        default:
            return state
    }
}

export default appStateReducer